import { render, staticRenderFns } from "./MovDiarios.vue?vue&type=template&id=23b17b7a&"
import script from "./MovDiarios.vue?vue&type=script&lang=js&"
export * from "./MovDiarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports